// eslint-disable-next-line no-restricted-syntax
export enum PlacementApplicationStatus {
  APPLIED = "applied",
  ACCEPTED = "accepted",
  INTERVIEW = "interview",
  INTERVIEW_PENDING = "interview:pending",
  INTERVIEW_NOT_CONFIRMED = "interview:notConfirmed",
  INTERVIEW_CONFIRMED = "interview:confirmed",
  INTERVIEW_CANCELLED = "interview:cancelled",
  INTERVIEW_NOT_SHOWED = "interview:notShowed",
  INTERVIEW_HELD = "interview:held",
  TURNED_AWAY = "interview:turnedAway",
  OFFER = "offer",
  OFFER_REJECTED = "offer:rejected",
  HIRED = "hired",
  ONBOARDING = "hired:onboarding",
  RETAINED = "hired:retained",
  RESIGNED = "hired:resigned",
  REJECTED = "rejected",
}
